/**
 * @deprecated please use @website/ui instead
 */
export * from "./top-app-bar";
/**
 * @deprecated please use @website/ui instead
 */
export * from "./top-app-bar.types";
